<template>

    <div>
        <nav class="navbar navbar-expand-lg bg-light">
            <div class="container-fluid">
                <span class="navbar-brand mb-0 h1">Theme Editor</span>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false"
                        aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNavDropdown">
                    <ul class="navbar-nav">
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                               aria-expanded="false">
                                Select Theme
                            </a>
                            <ul class="dropdown-menu">
                                <li v-for="theme in model.themes"><a class="dropdown-item" href="javascript:void(0)" @click="onThemeSelected(theme)">{{theme.name}}</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div>
                    <button @click="onNewClick" class="btn btn-danger btn-sm">new theme</button>
                    <button v-if="model.currentUser.id === null" @click="showSignUpModal = true" class="btn btn-success btn-sm text-white">Sign Up</button>
                    <a v-else href="javascript:void(0)" @click="onLogoutClick" class="btn btn-light btn-sm">Logout</a>
                </div>
            </div>
        </nav>

        <div class="d-flex" v-if="theme && model.fonts.length > 0">
            <theme-sidebar :theme="theme" :dynamic-classes="'sidebar-nav'"></theme-sidebar>
            <example-theme-content :theme="theme"></example-theme-content>
        </div>

        <sign-in-modal v-if="showSignInModal" @noEvent="showSignInModal = false" :switch-to-sign-up="onSwitchToSignUp"></sign-in-modal>
        <sign-up-modal v-if="showSignUpModal" @noEvent="showSignUpModal = false" :switch-to-sign-in="onSwitchToSignIn"></sign-up-modal>
        <new-theme-modal v-if="showNewThemeModal" @noEvent="showNewThemeModal = false" :yes-event="onNewThemeCreated" ></new-theme-modal>
    </div>
</template>

<script>
import ResourcesService from "./services/ResourcesService";
import ThemeSidebar from "./theme/ThemeSidebar.vue";
import ThemeService from "./services/ThemeService";
import ExampleThemeContent from "./theme/ExampleThemeContent.vue";
import SignInModal from "./components/SignInModal.vue";
import SignUpModal from "./components/SignUpModal.vue";
import UserService from "./services/UserService";
import NewThemeModal from "./theme/NewThemeModal.vue";
import ThemeLoader from "./utils/ThemeLoader";

export default {
    name: 'ThemeApp',
    components: {NewThemeModal, SignUpModal, SignInModal, ExampleThemeContent, ThemeSidebar},
    data() {
        return {
            model: webase.model,
            showSignInModal: false,
            showSignUpModal: false,
            theme: null,
            onSwitchToSignUp: () => { this.showSignUpModal = true },
            onSwitchToSignIn: () => { this.showSignInModal = true },
            showNewThemeModal: false,
            onNewThemeCreated: (newTheme) => { this.createNewTheme(newTheme) },
        }
    },
    mounted() {
        let resourcesService = new ResourcesService()
        let url = webase.utils.app.getBaseUrl() + '/resources/webase-fonts.json?t=' + Date.now()
        resourcesService.get(url).then((response) => {
            this.model.fonts = response
        })

        let service = new ThemeService()
        service.list().then((response) => {
            console.log('themes loaded')
            console.log(response)

            if(response.length > 0) {
                this.model.themes = response
                this.theme = this.model.themes[0]
                this.loadStyleResources()
            }

        }).catch((message) => {
            console.log('error loading themes')
            console.log(message)
        })
    },
    methods: {

        onThemeSelected(theme) {
            this.theme = theme
            this.loadStyleResources()
        },

        loadStyleResources() {
            webase.utils.font.loadThemeFonts(this.theme)
            webase.utils.ui.injectTempCss(`themes/${this.theme.id}`)
        },

        onNewClick() {
            this.showNewThemeModal = true
        },

        createNewTheme(newTheme) {
            let defaultTheme = webase.utils.theme.convertToFullTheme(newTheme)
            this.theme = {...defaultTheme}
            ThemeLoader.previewTheme(this.theme)
        },

        onLogoutClick() {
            let service = new UserService()

            service.logout().then((response) => {
                this.model.auth_token = this.model.user_id = this.model.currentUser.id = null
            }).catch((error) => {
                console.log(error)
            })
        }
    }
}
</script>

<style>

</style>
